module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace6_dettaglio-280bafc6802aa23cc2ad4f038807e833.jpg";